// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visibility-div
{
    
    
    text-align: center;
    font-size: 10px;
    
}

.visibility-canvas
{
    width: 100%;
    height: 100%;
    
    
}
.visibility-div-current
{
    margin: 2px;
    width:calc(100% - 4px);
    height: 65%;
    background-color: red;
    border-radius: 3px;
    
}

`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/lisibility/lisibility.css"],"names":[],"mappings":"AAAA;;;;IAII,kBAAkB;IAClB,eAAe;;AAEnB;;AAEA;;IAEI,WAAW;IACX,YAAY;;;AAGhB;AACA;;IAEI,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;;AAEtB","sourcesContent":[".visibility-div\n{\n    \n    \n    text-align: center;\n    font-size: 10px;\n    \n}\n\n.visibility-canvas\n{\n    width: 100%;\n    height: 100%;\n    \n    \n}\n.visibility-div-current\n{\n    margin: 2px;\n    width:calc(100% - 4px);\n    height: 65%;\n    background-color: red;\n    border-radius: 3px;\n    \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
